import axiosInstance from "../Middleware/interceptor";
// import { toast } from "react-toastify";

/**
 * Handles API errors consistently
 * @param error The error object
 */
const handleApiError = (error) => {
  let errorMessage = 'An unexpected error occurred';

  if (error.response) {
    // Server responded with a non-2xx status
    errorMessage = error.response.data?.message || error.response.statusText || 'Request failed';
  } else if (error.request) {
    // No response received
    errorMessage = 'No response from server. Please check your connection.';
  } else {
    // Setup error
    errorMessage = error.message;
  }

  // toast.error(errorMessage);
  return error;
};

/**
 * Handles API success responses consistently
 * @param response The API response
 * @param showSuccessToast Whether to show success toast
 */
const handleSuccessResponse = (response, showSuccessToast = true) => {
  if (response?.data?.statusCode === 200 && showSuccessToast) {
    // toast.success(response.data.message);
  } else if (response?.data?.statusCode !== 200 && response?.data?.message) {
    // toast.error(response.data.message);s 
  }
  return response.data;
};

/**
 * POST request wrapper
 * @param url API endpoint
 * @param data Request payload
 * @param showSuccessToast Whether to show success toast
 * @returns Promise with response data
 */
export const postApi = async (url, data, showSuccessToast = true) => {
  try {
    const response = await axiosInstance.post(url, data);
    return handleSuccessResponse(response, showSuccessToast);
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * GET request wrapper
 * @param url API endpoint
 * @param showSuccessToast Whether to show success toast
 * @returns Promise with response data
 */
export const getApi = async (url, showSuccessToast = false) => {
  try {
    const response = await axiosInstance.get(url);
    return handleSuccessResponse(response, showSuccessToast);
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * PUT request wrapper
 * @param url API endpoint
 * @param data Request payload
 * @param showSuccessToast Whether to show success toast
 * @returns Promise with response data
 */
export const putApi = async (url, data, showSuccessToast = true) => {
  try {
    const response = await axiosInstance.put(url, data);
    return handleSuccessResponse(response, showSuccessToast);
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * DELETE request wrapper
 * @param url API endpoint
 * @param data Request payload (optional)
 * @param showSuccessToast Whether to show success toast
 * @returns Promise with response data
 */
export const deleteApi = async (url, data = null, showSuccessToast = true) => {
  try {
    const config = data ? { data } : {};
    const response = await axiosInstance.delete(url, config);
    return handleSuccessResponse(response, showSuccessToast);
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * PATCH request wrapper
 * @param url API endpoint
 * @param data Request payload
 * @param showSuccessToast Whether to show success toast
 * @returns Promise with response data
 */
export const patchApi = async (url, data, showSuccessToast = true) => {
  try {
    const response = await axiosInstance.patch(url, data);
    return handleSuccessResponse(response, showSuccessToast);
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Get dashboard statistics including user count
 * @returns Promise with dashboard statistics
 */
export const getDashboardStats = async () => {
  try {
    const response = await getApi('user-count');
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Get user count specifically
 * @returns Promise with user count data
 */
export const getUserCount = async () => {
  try {
    const response = await getApi('admin/user-count');
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Get analytics data
 * @returns Promise with analytics data
 */
export const getAnalytics = async () => {
  try {
    const response = await getApi('/analytics');
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};